import {operationKey,write} from './api';
import type {CodexExecutionResult} from '../shared/operations';
type Intent={key:string;pending:Promise<CodexExecutionResult>|null};
const intents=new Map<string,Intent>();
/** Actor changes must not carry an earlier staff member's retry identity. */
export function clearOfficeUnitRequests(){intents.clear();}
/** Recover an unresolved request even if readiness or the source job has changed. */
export function hasOfficeUnitRequest(jobId:string,actorId:string){return intents.has(actorId+'\0'+jobId);}

/** A lost HTTP response must replay the accepted request, not retry the source job. */
export function startOfficeUnit(jobId:string,actorId:string):Promise<CodexExecutionResult>{
 const scope=actorId+'\0'+jobId;
 const intent=intents.get(scope)??{key:operationKey(),pending:null};
 if(intent.pending)return intent.pending;
 intents.set(scope,intent);
 intent.pending=Promise.resolve().then(()=>{
  if(intents.get(scope)!==intent)throw new Error('Your sign-in session changed. Refresh the file review before starting AI analysis.');
  return write<CodexExecutionResult>('ai/codex/jobs/'+encodeURIComponent(jobId)+'/run','POST',{},intent.key);
 }).then(receipt=>{
  if(!receipt||typeof receipt!=='object'||Array.isArray(receipt)||receipt.jobId!==jobId||typeof receipt.status!=='string'||!receipt.status.trim()||typeof receipt.message!=='string')throw new Error('The office request returned an incomplete receipt. Retry the request to recover its saved result.');
  if(intents.get(scope)===intent)intents.delete(scope);
  return receipt;
 }).finally(()=>{if(intents.get(scope)===intent)intent.pending=null;});
 return intent.pending;
}
